import React from 'react';
import { LIFECYCLE, type LifecycleStatus, type Tone } from '../../lib/appointmentLifecycle';

const TONE_CLASSES: Record<Tone, string> = {
  neutral:  'bg-raise text-dim',
  progress: 'bg-st-cy/10 text-st-cy',
  success:  'bg-st-ok/10 text-st-ok',
  warning:  'bg-st-warn/10 text-st-warn',
  danger:   'bg-st-bad/10 text-st-bad',
};

/** Badge de statut RDV — libellé et couleur pilotés par le contrat partagé (jamais en dur). */
const StatusBadge: React.FC<{ status: LifecycleStatus | null; className?: string }> = ({ status, className = '' }) => {
  if (!status) {
    return (
      <span className={`inline-flex items-center font-mono text-[10px] font-semibold px-2 py-0.5 rounded-md bg-raise text-faint ${className}`}>
        À statuer
      </span>
    );
  }
  const meta = LIFECYCLE[status];
  return (
    <span
      title={meta.description}
      className={`inline-flex items-center font-mono text-[10px] font-semibold px-2 py-0.5 rounded-md uppercase tracking-wide ${TONE_CLASSES[meta.tone]} ${className}`}
    >
      {meta.label}
    </span>
  );
};

export default StatusBadge;
